<template>
     <el-col :xs="{span:24}" :md="width" v-show="show">
         <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
        
            <el-select-v2
                v-if="isSelect"
                :options="options"
                multiple
                class="qweelement"
                :modelValue="(data[name] || [])"
                @update:modelValue="newValue => data[name] = newValue"
                clearable
                @visible-change="visibleChange"
                :filterable = "isFilterAble"
                :allow-create="isAddable"
                :disabled = "disabled"
                placeholder="请选择">
            </el-select-v2>

            <div v-if="!isSelect">
                <el-checkbox-group
                    v-model="data[name]"
                    :disabled = "disabled">
                    <el-checkbox
                        v-for="item in options"
                        :key="item.Value"
                        :value="item.Value"
                        :label="item.Value">
                        {{ item.Label }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
     </el-col>
</template>

<script>
    import baseChoiceProField from "./BaseMultChoiceProField" 
    export default{
        name:"MultChoiceProField",
        mixins:[baseChoiceProField]
    }
</script>